var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProSearchRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0478 10.5238C20.0478 8.64018 19.4892 6.79883 18.4427 5.23265C17.3962 3.66647 15.9089 2.44577 14.1686 1.72494C12.4283 1.00411 10.5133 0.815527 8.66588 1.18301C6.81841 1.55049 5.12145 2.45757 3.78951 3.78949C2.45757 5.12142 1.55048 6.81835 1.18299 8.66578C0.815513 10.5132 1.00415 12.4282 1.72499 14.1684C2.44583 15.9087 3.66655 17.3961 5.23275 18.4426C6.79894 19.489 8.64026 20.0476 10.5239 20.0476",
    stroke: "#E4151B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5237H20.0478",
    stroke: "#E4151B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.524 20.0476C8.68593 20.0476 7.19067 15.7809 7.19067 10.5238C7.19067 5.26666 8.68593 1 10.524 1C12.3622 1 13.8574 5.26666 13.8574 10.5238",
    stroke: "#E4151B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5897 19.9238C18.4307 19.9238 19.9231 18.4314 19.9231 16.5904C19.9231 14.7495 18.4307 13.2571 16.5897 13.2571C14.7487 13.2571 13.2563 14.7495 13.2563 16.5904C13.2563 18.4314 14.7487 19.9238 16.5897 19.9238Z",
    stroke: "#E4151B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20.9999L18.9429 18.9523",
    stroke: "#E4151B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProSearchRed);
export default __webpack_public_path__ + "static/media/ic-pro-search-red.18bf6cdab0efbd6f88cade6cf4f51052.svg";
export { ForwardRef as ReactComponent };